<template>
  <div>
    <section class="row" style="margin-left:1px;margin-right:1px;">
      <b-col sm="12">
        <div class="form-horizontal">
          <h1
            v-if="$store.state.wishlistType === 'wishlist'"
            class="section-heading mb-2"
          >
            Our Wedding Day
          </h1>
          <h1
            v-if="$store.state.wishlistType === 'giftlist'"
            class="section-heading mb-2"
          >
            Celebration
          </h1>
          <div class="form-group form-group-venue">
            <label for="" class="col-sm-2 control-label"></label>
            <b-col sm="12">
              <h4 class="text-center">
                <i class="material-icons" style="transform:rotate(180deg);"
                  >format_quote</i
                >
                {{ $store.state.user.couple_title }}
                <i class="material-icons">format_quote</i>
              </h4>
              <hr />
            </b-col>
          </div>

          <div class="form-group form-group-venue">
            <div class="panel-body">
              <section class="row" style="margin-left:1px;margin-right:1px;">
                <div
                  :class="{
                    'col-sm-12': !$store.state.user.wedding_night.time,
                    'col-sm-6': $store.state.user.wedding_night.time
                  }"
                >
                  <h3 class="text-center">Ceremony Venue</h3>
                  <ul class="list-unstyled text-center" style="line-height: 2;">
                    <li>
                      Date of Ceremony:
                      <strong
                        ><span>{{
                          $store.state.user.wedding_day.date
                        }}</span></strong
                      >
                    </li>
                    <li v-if="$store.state.user.wedding_day.time">
                      Time of Ceremony:
                      <strong
                        ><span>{{
                          $store.state.user.wedding_day.time
                        }}</span></strong
                      >
                    </li>
                    <li v-if="$store.state.user.wedding_day.name">
                      Name:
                      <strong
                        ><span>{{
                          $store.state.user.wedding_day.name
                        }}</span></strong
                      >
                    </li>
                    <li v-if="$store.state.user.wedding_day.address">
                      Address:
                      <strong
                        ><span>{{
                          $store.state.user.wedding_day.address
                        }}</span></strong
                      >
                    </li>
                    <li v-if="$store.state.user.wedding_day.website">
                      Website: <span>
                        <a :href="$store.state.user.wedding_day.website" target="_blank">Ceremony Website</a>
                      </span>
                    </li>
                  </ul>
                </div>
                <div
                  class="col-sm-12"
                >
                  <h3 class="text-center">Reception Venue</h3>
                  <ul class="list-unstyled text-center" style="line-height: 2;">
                    <li v-if=" $store.state.user.wedding_night.date">
                      Date of Reception:
                      <strong
                        ><span>{{
                          $store.state.user.wedding_night.date
                        }}</span></strong
                      >
                    </li>
                    <li v-if="$store.state.user.wedding_night.time">
                      Time of Reception:
                      <strong
                        ><span>{{
                          $store.state.user.wedding_night.time
                        }}</span></strong
                      >
                    </li>
                    <li v-if="$store.state.user.wedding_night.name">
                      Name:
                      <strong
                        ><span>{{
                          $store.state.user.wedding_night.name
                        }}</span></strong
                      >
                    </li>
                    <li v-if="$store.state.user.wedding_night.address">
                      Address:
                      <strong
                        ><span>{{
                          $store.state.user.wedding_night.address
                        }}</span></strong
                      >
                    </li>
                    <li v-if="$store.state.user.wedding_night.website">
                      Website: <span>
                        <a :href="$store.state.user.wedding_night.website" target="_blank">Reception Website</a>
                      </span>
                    </li>
                  </ul>
                </div>
              </section>
              <section v-show="$store.state.user.where_to_stay.length > 0">
                <hr />
                <div>
                  <h3 class="text-center">Where To Stay</h3>
                  <ul class="list-unstyled text-center" style="line-height: 2;">
                    <li
                      v-for="location in $store.state.user.where_to_stay"
                      :key="location.url"
                    >
                      <strong>
                        <span>
                          <a
                            rel="noreferer"
                            :href="location.url"
                            target="_blank"
                            >{{ location.name }}</a
                          >
                        </span>
                      </strong>
                    </li>
                  </ul>
                </div>
              </section>
              <hr class="hr-02" />
              <p class="lead text-center">
                We&#39;re looking forward to sharing this special day with you.
              </p>
            </div>
          </div>
        </div>
      </b-col>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meta: {
        loaded: true
      }
    };
  },
  methods: {},
  mounted() {
    this.meta.loaded = true;
  }
};
</script>
